<template>
  <div no-body class="lookup">
    <!-- <b-row v-if="lkuLoading" class="justify-content-center mb-2"
      ><span style="color: blue">Loading data ...</span></b-row
    > -->
    <b-row>
      <b-col cols="12">
        <b-form-group label-cols="1" label="Filter">
          <b-form-row>
            <b-col cols="3">
              <b-form-input
                v-model="tblData.kodevendor"
                placeholder="Kode Vendor"
                @keyup.13.native="refresh()"
              ></b-form-input>
            </b-col>
            <b-col cols="3">
              <b-form-input
                v-model="tblData.namavendor"
                placeholder="Nama Vendor"
                @keyup.13.native="refresh()"
              ></b-form-input>
            </b-col>
            <b-col cols="3">
              <b-form-input
                v-model="tblData.alamat"
                placeholder="Alamat"
                @keyup.13.native="refresh()"
              ></b-form-input>
            </b-col>
            <!-- <b-col cols="3">
              <b-form-input
                v-model="tblData.crewhp"
                placeholder="No HP"
                @keyup.13.native="refresh()"
              ></b-form-input>
            </b-col> -->
          </b-form-row>
        </b-form-group>
        <!-- <b-form-group label-cols="1">
          <b-form-row>
            <b-col cols="6">
              <b-form-input
                v-model="tblData.jabatan"
                placeholder="Job Title"
                @keyup.13.native="refresh()"
              ></b-form-input>
            </b-col>
            <b-col cols="6">
              <b-form-input
                v-model="tblData.departemen"
                placeholder="Department"
                @keyup.13.native="refresh()"
              ></b-form-input>
            </b-col>
          </b-form-row>
        </b-form-group> -->
      </b-col>
    </b-row>
    <b-card no-body class="mt-2">
      <b-table
        class="mb-0"
        ref="tblKolektor"
        style="font-size: smaller"
        responsive
        striped
        hover
        :items="data"
        :fields="fields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="selectItem"
        :busy="lkuLoading"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(nomor)="data">{{ data.index + 1 }}</template>
        <template v-slot:cell(crewmail)="data">{{
          data.item.crewmail || ""
        }}</template>
        <template v-slot:cell(crewhp)="data">{{
          data.item.crewhp || ""
        }}</template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of
            {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="3">
          <b-row class="ml-2 mt-2">
            <span class="pt-1 pr-2">Limit per page</span>
            <b-form-select
              :options="[10, 15, 20, 25]"
              :plain="true"
              v-model="tblData.limit"
              size="sm"
              style="width: 80px !important"
            />
          </b-row>
        </b-col>
        <b-col cols="5">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import crud from "../../apis/crud";

export default {
  data() {
    return {
      fields: [
        {
          key: "nomor",
          thStyle: "width:50px",
          label: "No.",
        },
        {
          key: "kodevendor",
          label: "Kode Vendor",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "namavendor",
          label: "Nama Vendor",
          thClass: "text-center",
          sortable: true,
        },

        {
          key: "telepon",
          label: "Telpon",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "kota",
          label: "Kota",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "alamat",
          label: "Alamat",
          thClass: "text-center",
          sortable: true,
        },
      ],
      tblData: {
        tablename: "vwvendoroutsource",
        page: 1,
        limit: 20,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
      lkuLoading: false,
    };
  },
  props: ["compcode"],
  // created: async function() {
  //     this.$emit('update:compcode', this.$store.state.user.compcode);
  // },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function (ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.compcode = this.compcode;
      this.lkuLoading = true;
       const keys = ["kodevendor", "namavendor", "alamat"];
        const obj = this.tblData;
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "";
            str += `${key}=`+`%${encodeURIComponent(obj[key])}%`;
          }
        }
    this.tblData.customQuery = str;
      const list = await crud.list(this.tblData);
      this.lkuLoading = false;
      return list;
    },
    selectItem(item, index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
      this.tblData = { crewnik: "", crewname: "", jabatan: "", department: "" };
      this.refresh();
    },
    keymonitor: function (event) {
      if (event.key == "Enter") {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblKolektor.refresh();
      }
    },
    refresh() {
      this.$refs.tblKolektor.refresh();
    },
  },
};
</script>
